// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Edit User — theme-scoped under #adminRoot.user-form-theme (beats global .add-exercise / .input-detail) */

#adminRoot.user-form-theme {
  color: var(--text-color) !important;
  background-color: var(--bg-color) !important;
  transition: background-color 0.3s ease, color 0.3s ease;
}

html[data-theme="light"] #adminRoot.user-form-theme,
.light-mode #adminRoot.user-form-theme {
  color-scheme: light;
}

html[data-theme="dark"] #adminRoot.user-form-theme,
.dark-mode #adminRoot.user-form-theme {
  color-scheme: dark;
}

#adminRoot.user-form-theme .exercise-header > h2 {
  color: var(--text-color) !important;
}

#adminRoot.user-form-theme .back-btn {
  background-color: var(--surface-color, #161b26) !important;
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.12)) !important;
  color: var(--text-color) !important;
}

html[data-theme="light"] #adminRoot.user-form-theme .back-btn,
.light-mode #adminRoot.user-form-theme .back-btn {
  background-color: #ffffff !important;
  border-color: rgba(0, 0, 0, 0.1) !important;
}

#adminRoot.user-form-theme .edit-user-form.add-exercise,
#adminRoot.user-form-theme .add-exercise.edit-user-form {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 auto 16px !important;
  padding: 8px 14px 28px !important;
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  background-color: transparent !important;
  border-radius: 0 !important;
  overflow: visible !important;
  color: var(--text-color) !important;
}

#adminRoot.user-form-theme .edit-user-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#adminRoot.user-form-theme .edit-user-form .input_addpicsvg {
  display: none;
}

#adminRoot.user-form-theme .edit-user-form .visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

#adminRoot.user-form-theme .edit-user-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px 0 4px;
}

#adminRoot.user-form-theme .edit-user-form .edit-pic {
  position: relative;
  width: 112px;
  height: 112px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

#adminRoot.user-form-theme .edit-user-form .edit-pic img,
#adminRoot.user-form-theme .edit-user-form .profile_img_icon {
  width: 112px;
  height: 112px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--brand-primary, #0877bc);
  box-shadow: 0 8px 24px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
}

#adminRoot.user-form-theme .edit-user-form .profile_img_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877bc),
    var(--brand-primary-dark, #065a8f)
  );
  color: #fff;
  font-family: var(--brand-font, Poppins, sans-serif);
  font-size: 2.25rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

#adminRoot.user-form-theme .edit-user-form .edit-img-label {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  border: 3px solid var(--bg-color, #0b0f19);
  box-shadow: 0 4px 12px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4);
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),
    background-color 0.2s ease, filter 0.2s ease;
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .edit-img-label,
.light-mode #adminRoot.user-form-theme .edit-user-form .edit-img-label {
  border-color: #ffffff;
}

#adminRoot.user-form-theme .edit-user-form .edit-img-label:hover {
  background: var(--brand-primary-dark, #065a8f);
  transform: scale(1.06);
}

#adminRoot.user-form-theme .edit-user-form .edit-img-label:active {
  transform: scale(0.96);
}

#adminRoot.user-form-theme .edit-user-form .edit-img-label:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

#adminRoot.user-form-theme .edit-user-form .edit-camera {
  font-size: 15px;
}

/* Sections — dark by default (app default), light overrides */
#adminRoot.user-form-theme .edit-user-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-radius: 14px;
  background: #161b26 !important;
  background-color: #161b26 !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 8px 22px -16px rgba(0, 0, 0, 0.45);
  color: #f9fafb !important;
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-section,
.light-mode #adminRoot.user-form-theme .edit-user-section {
  background: #ffffff !important;
  background-color: #ffffff !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 4px 16px -8px rgba(0, 0, 0, 0.12);
  color: #111827 !important;
}

#adminRoot.user-form-theme .edit-user-section__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

#adminRoot.user-form-theme .edit-user-section__title {
  margin: 0;
  font-family: var(--brand-font, Poppins, sans-serif);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: inherit !important;
}

#adminRoot.user-form-theme .edit-user-section__count {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: var(--brand-primary, #0877bc);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);
}

#adminRoot.user-form-theme .edit-user-roles {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

#adminRoot.user-form-theme .edit-user-role {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 10px 12px;
  border-radius: 12px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  background: #1c2433 !important;
  color: #f9fafb !important;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-role,
.light-mode #adminRoot.user-form-theme .edit-user-role {
  background: #f3f4f6 !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  color: #111827 !important;
}

#adminRoot.user-form-theme .edit-user-role:hover {
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45) !important;
}

#adminRoot.user-form-theme .edit-user-role:active {
  transform: scale(0.99);
}

#adminRoot.user-form-theme .edit-user-role.is-active {
  border-color: var(--brand-primary, #0877bc) !important;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) !important;
}

#adminRoot.user-form-theme .edit-user-role input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 0;
  flex-shrink: 0;
  accent-color: var(--brand-primary, #0877bc);
  cursor: pointer;
}

#adminRoot.user-form-theme .edit-user-role__name {
  flex: 1 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
  color: inherit !important;
}

#adminRoot.user-form-theme .edit-user-role__copy {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

#adminRoot.user-form-theme .edit-user-role__copy .edit-user-role__name {
  flex: none;
}

#adminRoot.user-form-theme .edit-user-role__sub {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  color: var(--brand-text-secondary, #94a3b8);
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-role__sub,
.light-mode #adminRoot.user-form-theme .edit-user-role__sub {
  color: #64748b;
}

#adminRoot.user-form-theme .edit-user-role.is-active .edit-user-role__name {
  font-weight: 700;
  color: var(--brand-primary, #0877bc) !important;
}

#adminRoot.user-form-theme .edit-user-role__badge {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--brand-primary, #0877bc);
}

#adminRoot.user-form-theme .edit-user-hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
  color: #9ca3af !important;
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-hint,
.light-mode #adminRoot.user-form-theme .edit-user-hint {
  color: #4b5563 !important;
}

#adminRoot.user-form-theme .edit-user-hint--warn {
  color: #fbbf24 !important;
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-hint--warn,
.light-mode #adminRoot.user-form-theme .edit-user-hint--warn {
  color: #b45309 !important;
}

#adminRoot.user-form-theme .edit-user-empty {
  padding: 12px;
  border-radius: 10px;
  border: 1px dashed rgba(255, 255, 255, 0.2);
  color: #9ca3af !important;
  font-size: 13px;
  font-style: italic;
}

#adminRoot.user-form-theme .edit-user-fields {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

#adminRoot.user-form-theme .edit-user-form .input-detail {
  margin-top: 0 !important;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: transparent !important;
  background-color: transparent !important;
}

#adminRoot.user-form-theme .edit-user-form .input-detail > label,
#adminRoot.user-form-theme .edit-user-form .edit-user-label {
  margin: 0 !important;
  color: #f9fafb !important;
  font-family: var(--brand-font, Poppins, sans-serif);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail > label,
html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .edit-user-label,
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > label,
.light-mode #adminRoot.user-form-theme .edit-user-form .edit-user-label {
  color: #111827 !important;
}

/* Native inputs — solid dark fills (Safari ignores translucent bg on inputs) */
#adminRoot.user-form-theme .edit-user-form .input-detail > input,
#adminRoot.user-form-theme .edit-user-form .input-detail input[type="text"],
#adminRoot.user-form-theme .edit-user-form .input-detail input[type="email"],
#adminRoot.user-form-theme .edit-user-form .input-detail input[type="number"],
#adminRoot.user-form-theme .edit-user-form .input-detail input[type="date"],
#adminRoot.user-form-theme .edit-user-form .input-detail > select {
  height: 44px !important;
  width: 100% !important;
  padding: 0 12px !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
  border: 1px solid rgba(255, 255, 255, 0.14) !important;
  background: #0f141f !important;
  background-color: #0f141f !important;
  color: #f9fafb !important;
  -webkit-text-fill-color: #f9fafb !important;
  caret-color: #f9fafb !important;
  font-family: var(--brand-font, Poppins, sans-serif) !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  color-scheme: dark;
  appearance: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail > input,
html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail input[type="text"],
html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail input[type="email"],
html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail input[type="number"],
html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail input[type="date"],
html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail > select,
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > input,
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail input[type="text"],
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail input[type="email"],
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail input[type="number"],
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail input[type="date"],
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > select {
  background: #f3f4f6 !important;
  background-color: #f3f4f6 !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  color: #111827 !important;
  -webkit-text-fill-color: #111827 !important;
  caret-color: #111827 !important;
  color-scheme: light;
}

#adminRoot.user-form-theme .edit-user-form .input-detail > input::placeholder {
  color: #9ca3af !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #9ca3af !important;
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail > input::placeholder,
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > input::placeholder {
  color: #6b7280 !important;
  -webkit-text-fill-color: #6b7280 !important;
}

#adminRoot.user-form-theme .edit-user-form .input-detail > input:focus-visible,
#adminRoot.user-form-theme .edit-user-form .input-detail > select:focus-visible {
  outline: none !important;
  border-color: var(--brand-primary, #0877bc) !important;
  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28) !important;
}

#adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill,
#adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:hover,
#adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:focus {
  -webkit-text-fill-color: #f9fafb !important;
  box-shadow: 0 0 0 1000px #0f141f inset !important;
  caret-color: #f9fafb !important;
  -webkit-transition: background-color 99999s ease-in-out 0s;
  transition: background-color 99999s ease-in-out 0s;
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill,
html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:hover,
html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:focus,
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill,
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:hover,
.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:focus {
  -webkit-text-fill-color: #111827 !important;
  box-shadow: 0 0 0 1000px #f3f4f6 inset !important;
  caret-color: #111827 !important;
}

#adminRoot.user-form-theme .edit-user-form input[type="date"]::-webkit-calendar-picker-indicator {
  opacity: 0.85;
  cursor: pointer;
  filter: invert(1);
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form input[type="date"]::-webkit-calendar-picker-indicator,
.light-mode #adminRoot.user-form-theme .edit-user-form input[type="date"]::-webkit-calendar-picker-indicator {
  filter: none;
  opacity: 0.65;
}

#adminRoot.user-form-theme .edit-user-pair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

#adminRoot.user-form-theme .edit-user-gender {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

#adminRoot.user-form-theme .edit-user-gender__opt {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  background: #1c2433 !important;
  color: #f9fafb !important;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-gender__opt,
.light-mode #adminRoot.user-form-theme .edit-user-gender__opt {
  background: #f3f4f6 !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  color: #111827 !important;
}

#adminRoot.user-form-theme .edit-user-gender__opt input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

#adminRoot.user-form-theme .edit-user-gender__opt.is-active {
  border-color: var(--brand-primary, #0877bc) !important;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) !important;
  color: var(--brand-primary, #0877bc) !important;
}

#adminRoot.user-form-theme .edit-user-gender__opt:focus-within {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

#adminRoot.user-form-theme .edit-user-form .validation_error {
  margin-top: 0;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #fca5a5 !important;
  background: rgba(239, 68, 68, 0.16) !important;
  border-left: 3px solid #dc2626;
}

html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form .validation_error,
.light-mode #adminRoot.user-form-theme .edit-user-form .validation_error {
  color: #b91c1c !important;
  background: rgba(185, 28, 28, 0.1) !important;
}

#adminRoot.user-form-theme .edit-user-actions {
  display: flex;
  justify-content: stretch;
  padding-top: 4px;
}

#adminRoot.user-form-theme .edit-user-form .edit-user-submit {
  width: 100%;
  max-width: none;
  height: 48px;
  margin: 0;
  border: none;
  border-radius: 12px;
  background: var(--brand-primary, #0877bc) !important;
  color: #fff !important;
  font-family: var(--brand-font, Poppins, sans-serif);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 8px 20px -8px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55);
  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1),
    filter 0.2s ease, box-shadow 0.2s ease;
}

#adminRoot.user-form-theme .edit-user-form .edit-user-submit:hover {
  opacity: 1;
  filter: brightness(1.08);
  transform: translateY(-1px);
}

#adminRoot.user-form-theme .edit-user-form .edit-user-submit:active {
  transform: scale(0.98);
  filter: brightness(0.96);
}

#adminRoot.user-form-theme .edit-user-form .edit-user-submit:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 3px;
}

@media (min-width: 640px) {
  #adminRoot.user-form-theme .edit-user-fields {
    grid-template-columns: 1fr 1fr;
  }

  #adminRoot.user-form-theme .edit-user-field--full {
    grid-column: 1 / -1;
  }

  #adminRoot.user-form-theme .edit-user-pair {
    grid-column: 1 / -1;
  }
}

@media (min-width: 768px) {
  #adminRoot.user-form-theme .edit-user-form.add-exercise,
  #adminRoot.user-form-theme .add-exercise.edit-user-form {
    width: 100% !important;
    max-width: 720px !important;
    margin: 8px auto 24px !important;
    padding: 24px 28px 32px !important;
    border-radius: 16px !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    background: #161b26 !important;
    background-color: #161b26 !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35) !important;
  }

  html[data-theme="light"] #adminRoot.user-form-theme .edit-user-form.add-exercise,
  html[data-theme="light"] #adminRoot.user-form-theme .add-exercise.edit-user-form,
  .light-mode #adminRoot.user-form-theme .edit-user-form.add-exercise,
  .light-mode #adminRoot.user-form-theme .add-exercise.edit-user-form {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border-color: rgba(0, 0, 0, 0.08) !important;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08) !important;
  }

  #adminRoot.user-form-theme .edit-user-section {
    box-shadow: none;
    background: #1c2433 !important;
    background-color: #1c2433 !important;
  }

  html[data-theme="light"] #adminRoot.user-form-theme .edit-user-section,
  .light-mode #adminRoot.user-form-theme .edit-user-section {
    background: #f8f9fb !important;
    background-color: #f8f9fb !important;
    border-color: rgba(0, 0, 0, 0.06) !important;
  }

  #adminRoot.user-form-theme .edit-user-form .edit-pic,
  #adminRoot.user-form-theme .edit-user-form .edit-pic img,
  #adminRoot.user-form-theme .edit-user-form .profile_img_icon {
    width: 128px;
    height: 128px;
  }

  #adminRoot.user-form-theme .edit-user-form .profile_img_icon {
    font-size: 2.5rem;
  }

  #adminRoot.user-form-theme .edit-user-actions {
    justify-content: center;
  }

  #adminRoot.user-form-theme .edit-user-form .edit-user-submit {
    max-width: 280px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminLayout/EditUser.css"],"names":[],"mappings":"AAAA,2GAA2G;;AAE3G;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,uDAAuD;AACzD;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0DAA0D;EAC1D,2EAA2E;EAC3E,mCAAmC;AACrC;;AAEA;;EAEE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;EAC9B,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,+CAA+C;EAC/C,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;;GAIC;EACD,WAAW;EACX,mDAAmD;EACnD,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,0CAA0C;EAC1C,uEAAuE;EACvE,eAAe;EACf;gDAC8C;AAChD;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;EACpC,qDAAqD;EACrD,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,oCAAoC;EACpC,4CAA4C;EAC5C,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sDAAsD;EACtD,8BAA8B;EAC9B,yBAAyB;EACzB;gDAC8C;AAChD;;AAEA;;EAEE,8BAA8B;EAC9B,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sDAAsD;EACtD,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;EACd,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;;EAEE,oBAAoB;EACpB,yBAAyB;EACzB,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E;;;;;;EAME,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,sDAAsD;EACtD,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,2CAA2C;EAC3C,+BAA+B;EAC/B,8DAA8D;EAC9D,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAElB,gBAAgB;EAChB,oFAAoF;AACtF;;AAEA;;;;;;;;;;;;EAYE,8BAA8B;EAC9B,oCAAoC;EACpC,4CAA4C;EAC5C,yBAAyB;EACzB,2CAA2C;EAC3C,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;;EAEE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;;EAEE,wBAAwB;EACxB,sDAAsD;EACtD,kFAAkF;AACpF;;AAEA;;;EAGE,2CAA2C;EAC3C,iDAAiD;EACjD,+BAA+B;EAC/B,0DAAkD;EAAlD,kDAAkD;AACpD;;AAEA;;;;;;EAME,2CAA2C;EAC3C,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,sDAAsD;EACtD,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,+EAA+E;AACjF;;AAEA;;EAEE,8BAA8B;EAC9B,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,sDAAsD;EACtD,wEAAwE;EACxE,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,sBAAsB;EACtB,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6EAA6E;EAC7E;0CACwC;AAC1C;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,sBAAsB;IACtB,2BAA2B;IAC3B,gCAAgC;IAChC,kCAAkC;IAClC,8BAA8B;IAC9B,qDAAqD;IACrD,8BAA8B;IAC9B,oCAAoC;IACpC,sDAAsD;EACxD;;EAEA;;;;IAIE,8BAA8B;IAC9B,oCAAoC;IACpC,4CAA4C;IAC5C,qDAAqD;EACvD;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;;IAEE,8BAA8B;IAC9B,oCAAoC;IACpC,4CAA4C;EAC9C;;EAEA;;;IAGE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Edit User — theme-scoped under #adminRoot.user-form-theme (beats global .add-exercise / .input-detail) */\n\n#adminRoot.user-form-theme {\n  color: var(--text-color) !important;\n  background-color: var(--bg-color) !important;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme,\n.light-mode #adminRoot.user-form-theme {\n  color-scheme: light;\n}\n\nhtml[data-theme=\"dark\"] #adminRoot.user-form-theme,\n.dark-mode #adminRoot.user-form-theme {\n  color-scheme: dark;\n}\n\n#adminRoot.user-form-theme .exercise-header > h2 {\n  color: var(--text-color) !important;\n}\n\n#adminRoot.user-form-theme .back-btn {\n  background-color: var(--surface-color, #161b26) !important;\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.12)) !important;\n  color: var(--text-color) !important;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .back-btn,\n.light-mode #adminRoot.user-form-theme .back-btn {\n  background-color: #ffffff !important;\n  border-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n#adminRoot.user-form-theme .edit-user-form.add-exercise,\n#adminRoot.user-form-theme .add-exercise.edit-user-form {\n  width: 100% !important;\n  max-width: 100% !important;\n  margin: 0 auto 16px !important;\n  padding: 8px 14px 28px !important;\n  border: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  background-color: transparent !important;\n  border-radius: 0 !important;\n  overflow: visible !important;\n  color: var(--text-color) !important;\n}\n\n#adminRoot.user-form-theme .edit-user-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n#adminRoot.user-form-theme .edit-user-form .input_addpicsvg {\n  display: none;\n}\n\n#adminRoot.user-form-theme .edit-user-form .visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n#adminRoot.user-form-theme .edit-user-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0 4px;\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-pic {\n  position: relative;\n  width: 112px;\n  height: 112px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-pic img,\n#adminRoot.user-form-theme .edit-user-form .profile_img_icon {\n  width: 112px;\n  height: 112px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid var(--brand-primary, #0877bc);\n  box-shadow: 0 8px 24px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n}\n\n#adminRoot.user-form-theme .edit-user-form .profile_img_icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877bc),\n    var(--brand-primary-dark, #065a8f)\n  );\n  color: #fff;\n  font-family: var(--brand-font, Poppins, sans-serif);\n  font-size: 2.25rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-img-label {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  border: 3px solid var(--bg-color, #0b0f19);\n  box-shadow: 0 4px 12px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4);\n  cursor: pointer;\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),\n    background-color 0.2s ease, filter 0.2s ease;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .edit-img-label,\n.light-mode #adminRoot.user-form-theme .edit-user-form .edit-img-label {\n  border-color: #ffffff;\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-img-label:hover {\n  background: var(--brand-primary-dark, #065a8f);\n  transform: scale(1.06);\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-img-label:active {\n  transform: scale(0.96);\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-img-label:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-camera {\n  font-size: 15px;\n}\n\n/* Sections — dark by default (app default), light overrides */\n#adminRoot.user-form-theme .edit-user-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px;\n  border-radius: 14px;\n  background: #161b26 !important;\n  background-color: #161b26 !important;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  box-shadow: 0 8px 22px -16px rgba(0, 0, 0, 0.45);\n  color: #f9fafb !important;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-section,\n.light-mode #adminRoot.user-form-theme .edit-user-section {\n  background: #ffffff !important;\n  background-color: #ffffff !important;\n  border-color: rgba(0, 0, 0, 0.08) !important;\n  box-shadow: 0 4px 16px -8px rgba(0, 0, 0, 0.12);\n  color: #111827 !important;\n}\n\n#adminRoot.user-form-theme .edit-user-section__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n#adminRoot.user-form-theme .edit-user-section__title {\n  margin: 0;\n  font-family: var(--brand-font, Poppins, sans-serif);\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: inherit !important;\n}\n\n#adminRoot.user-form-theme .edit-user-section__count {\n  flex-shrink: 0;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--brand-primary, #0877bc);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);\n}\n\n#adminRoot.user-form-theme .edit-user-roles {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n#adminRoot.user-form-theme .edit-user-role {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 48px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  cursor: pointer;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  background: #1c2433 !important;\n  color: #f9fafb !important;\n  transition: background-color 0.2s ease, border-color 0.2s ease,\n    transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-role,\n.light-mode #adminRoot.user-form-theme .edit-user-role {\n  background: #f3f4f6 !important;\n  border-color: rgba(0, 0, 0, 0.08) !important;\n  color: #111827 !important;\n}\n\n#adminRoot.user-form-theme .edit-user-role:hover {\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45) !important;\n}\n\n#adminRoot.user-form-theme .edit-user-role:active {\n  transform: scale(0.99);\n}\n\n#adminRoot.user-form-theme .edit-user-role.is-active {\n  border-color: var(--brand-primary, #0877bc) !important;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) !important;\n}\n\n#adminRoot.user-form-theme .edit-user-role input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  flex-shrink: 0;\n  accent-color: var(--brand-primary, #0877bc);\n  cursor: pointer;\n}\n\n#adminRoot.user-form-theme .edit-user-role__name {\n  flex: 1;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.35;\n  color: inherit !important;\n}\n\n#adminRoot.user-form-theme .edit-user-role__copy {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n#adminRoot.user-form-theme .edit-user-role__copy .edit-user-role__name {\n  flex: none;\n}\n\n#adminRoot.user-form-theme .edit-user-role__sub {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.35;\n  color: var(--brand-text-secondary, #94a3b8);\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-role__sub,\n.light-mode #adminRoot.user-form-theme .edit-user-role__sub {\n  color: #64748b;\n}\n\n#adminRoot.user-form-theme .edit-user-role.is-active .edit-user-role__name {\n  font-weight: 700;\n  color: var(--brand-primary, #0877bc) !important;\n}\n\n#adminRoot.user-form-theme .edit-user-role__badge {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--brand-primary, #0877bc);\n}\n\n#adminRoot.user-form-theme .edit-user-hint {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #9ca3af !important;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-hint,\n.light-mode #adminRoot.user-form-theme .edit-user-hint {\n  color: #4b5563 !important;\n}\n\n#adminRoot.user-form-theme .edit-user-hint--warn {\n  color: #fbbf24 !important;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-hint--warn,\n.light-mode #adminRoot.user-form-theme .edit-user-hint--warn {\n  color: #b45309 !important;\n}\n\n#adminRoot.user-form-theme .edit-user-empty {\n  padding: 12px;\n  border-radius: 10px;\n  border: 1px dashed rgba(255, 255, 255, 0.2);\n  color: #9ca3af !important;\n  font-size: 13px;\n  font-style: italic;\n}\n\n#adminRoot.user-form-theme .edit-user-fields {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n#adminRoot.user-form-theme .edit-user-form .input-detail {\n  margin-top: 0 !important;\n  width: 100%;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  background: transparent !important;\n  background-color: transparent !important;\n}\n\n#adminRoot.user-form-theme .edit-user-form .input-detail > label,\n#adminRoot.user-form-theme .edit-user-form .edit-user-label {\n  margin: 0 !important;\n  color: #f9fafb !important;\n  font-family: var(--brand-font, Poppins, sans-serif);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail > label,\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .edit-user-label,\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > label,\n.light-mode #adminRoot.user-form-theme .edit-user-form .edit-user-label {\n  color: #111827 !important;\n}\n\n/* Native inputs — solid dark fills (Safari ignores translucent bg on inputs) */\n#adminRoot.user-form-theme .edit-user-form .input-detail > input,\n#adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"text\"],\n#adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"email\"],\n#adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"number\"],\n#adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"date\"],\n#adminRoot.user-form-theme .edit-user-form .input-detail > select {\n  height: 44px !important;\n  width: 100% !important;\n  padding: 0 12px !important;\n  box-sizing: border-box !important;\n  border-radius: 10px !important;\n  border: 1px solid rgba(255, 255, 255, 0.14) !important;\n  background: #0f141f !important;\n  background-color: #0f141f !important;\n  color: #f9fafb !important;\n  -webkit-text-fill-color: #f9fafb !important;\n  caret-color: #f9fafb !important;\n  font-family: var(--brand-font, Poppins, sans-serif) !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  color-scheme: dark;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail > input,\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"text\"],\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"email\"],\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"number\"],\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"date\"],\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail > select,\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > input,\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"text\"],\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"email\"],\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"number\"],\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail input[type=\"date\"],\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > select {\n  background: #f3f4f6 !important;\n  background-color: #f3f4f6 !important;\n  border-color: rgba(0, 0, 0, 0.12) !important;\n  color: #111827 !important;\n  -webkit-text-fill-color: #111827 !important;\n  caret-color: #111827 !important;\n  color-scheme: light;\n}\n\n#adminRoot.user-form-theme .edit-user-form .input-detail > input::placeholder {\n  color: #9ca3af !important;\n  opacity: 1 !important;\n  -webkit-text-fill-color: #9ca3af !important;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail > input::placeholder,\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > input::placeholder {\n  color: #6b7280 !important;\n  -webkit-text-fill-color: #6b7280 !important;\n}\n\n#adminRoot.user-form-theme .edit-user-form .input-detail > input:focus-visible,\n#adminRoot.user-form-theme .edit-user-form .input-detail > select:focus-visible {\n  outline: none !important;\n  border-color: var(--brand-primary, #0877bc) !important;\n  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28) !important;\n}\n\n#adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill,\n#adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:hover,\n#adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:focus {\n  -webkit-text-fill-color: #f9fafb !important;\n  box-shadow: 0 0 0 1000px #0f141f inset !important;\n  caret-color: #f9fafb !important;\n  transition: background-color 99999s ease-in-out 0s;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill,\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:hover,\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:focus,\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill,\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:hover,\n.light-mode #adminRoot.user-form-theme .edit-user-form .input-detail > input:-webkit-autofill:focus {\n  -webkit-text-fill-color: #111827 !important;\n  box-shadow: 0 0 0 1000px #f3f4f6 inset !important;\n  caret-color: #111827 !important;\n}\n\n#adminRoot.user-form-theme .edit-user-form input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  opacity: 0.85;\n  cursor: pointer;\n  filter: invert(1);\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form input[type=\"date\"]::-webkit-calendar-picker-indicator,\n.light-mode #adminRoot.user-form-theme .edit-user-form input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  filter: none;\n  opacity: 0.65;\n}\n\n#adminRoot.user-form-theme .edit-user-pair {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n#adminRoot.user-form-theme .edit-user-gender {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n#adminRoot.user-form-theme .edit-user-gender__opt {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  background: #1c2433 !important;\n  color: #f9fafb !important;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-gender__opt,\n.light-mode #adminRoot.user-form-theme .edit-user-gender__opt {\n  background: #f3f4f6 !important;\n  border-color: rgba(0, 0, 0, 0.08) !important;\n  color: #111827 !important;\n}\n\n#adminRoot.user-form-theme .edit-user-gender__opt input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n#adminRoot.user-form-theme .edit-user-gender__opt.is-active {\n  border-color: var(--brand-primary, #0877bc) !important;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) !important;\n  color: var(--brand-primary, #0877bc) !important;\n}\n\n#adminRoot.user-form-theme .edit-user-gender__opt:focus-within {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n#adminRoot.user-form-theme .edit-user-form .validation_error {\n  margin-top: 0;\n  padding: 6px 10px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #fca5a5 !important;\n  background: rgba(239, 68, 68, 0.16) !important;\n  border-left: 3px solid #dc2626;\n}\n\nhtml[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form .validation_error,\n.light-mode #adminRoot.user-form-theme .edit-user-form .validation_error {\n  color: #b91c1c !important;\n  background: rgba(185, 28, 28, 0.1) !important;\n}\n\n#adminRoot.user-form-theme .edit-user-actions {\n  display: flex;\n  justify-content: stretch;\n  padding-top: 4px;\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-user-submit {\n  width: 100%;\n  max-width: none;\n  height: 48px;\n  margin: 0;\n  border: none;\n  border-radius: 12px;\n  background: var(--brand-primary, #0877bc) !important;\n  color: #fff !important;\n  font-family: var(--brand-font, Poppins, sans-serif);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 8px 20px -8px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55);\n  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1),\n    filter 0.2s ease, box-shadow 0.2s ease;\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-user-submit:hover {\n  opacity: 1;\n  filter: brightness(1.08);\n  transform: translateY(-1px);\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-user-submit:active {\n  transform: scale(0.98);\n  filter: brightness(0.96);\n}\n\n#adminRoot.user-form-theme .edit-user-form .edit-user-submit:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 3px;\n}\n\n@media (min-width: 640px) {\n  #adminRoot.user-form-theme .edit-user-fields {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  #adminRoot.user-form-theme .edit-user-field--full {\n    grid-column: 1 / -1;\n  }\n\n  #adminRoot.user-form-theme .edit-user-pair {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (min-width: 768px) {\n  #adminRoot.user-form-theme .edit-user-form.add-exercise,\n  #adminRoot.user-form-theme .add-exercise.edit-user-form {\n    width: 100% !important;\n    max-width: 720px !important;\n    margin: 8px auto 24px !important;\n    padding: 24px 28px 32px !important;\n    border-radius: 16px !important;\n    border: 1px solid rgba(255, 255, 255, 0.1) !important;\n    background: #161b26 !important;\n    background-color: #161b26 !important;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35) !important;\n  }\n\n  html[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-form.add-exercise,\n  html[data-theme=\"light\"] #adminRoot.user-form-theme .add-exercise.edit-user-form,\n  .light-mode #adminRoot.user-form-theme .edit-user-form.add-exercise,\n  .light-mode #adminRoot.user-form-theme .add-exercise.edit-user-form {\n    background: #ffffff !important;\n    background-color: #ffffff !important;\n    border-color: rgba(0, 0, 0, 0.08) !important;\n    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08) !important;\n  }\n\n  #adminRoot.user-form-theme .edit-user-section {\n    box-shadow: none;\n    background: #1c2433 !important;\n    background-color: #1c2433 !important;\n  }\n\n  html[data-theme=\"light\"] #adminRoot.user-form-theme .edit-user-section,\n  .light-mode #adminRoot.user-form-theme .edit-user-section {\n    background: #f8f9fb !important;\n    background-color: #f8f9fb !important;\n    border-color: rgba(0, 0, 0, 0.06) !important;\n  }\n\n  #adminRoot.user-form-theme .edit-user-form .edit-pic,\n  #adminRoot.user-form-theme .edit-user-form .edit-pic img,\n  #adminRoot.user-form-theme .edit-user-form .profile_img_icon {\n    width: 128px;\n    height: 128px;\n  }\n\n  #adminRoot.user-form-theme .edit-user-form .profile_img_icon {\n    font-size: 2.5rem;\n  }\n\n  #adminRoot.user-form-theme .edit-user-actions {\n    justify-content: center;\n  }\n\n  #adminRoot.user-form-theme .edit-user-form .edit-user-submit {\n    max-width: 280px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
